<template>
  <div class="expired-container">
    <el-table :data="productList"
              size="mini"
              style="width: 100%"
              height="100%">
      <el-table-column prop="createOn"
                       label="创建时间"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.createOn | date }}
        </template>
      </el-table-column>
      <el-table-column prop="productName"
                       label="物料名称"
                       width="250">
      </el-table-column>
      <el-table-column label="品项">
        <template slot-scope="scope">
          <el-tag :type="scope.row.qualityName | qualityType"
                  size="mini">
            {{ scope.row.qualityName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="quantity"
                       label="数量"> </el-table-column>
      <el-table-column prop="price"
                       label="价格"> </el-table-column>
      <el-table-column prop="priceDate"
                       label="价格有效期"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.priceDate | date }}
        </template>
      </el-table-column>
      <el-table-column prop="remark"
                       label="备注"
                       width="200">
      </el-table-column>
      <el-table-column label="产品图片">
        <template slot-scope="scope">
          <el-image style="width: 40px; height: 40px"
                    v-if="scope.row.uploadFiles.length > 0"
                    :src="scope.row.uploadFiles[0].sitePath"
                    :preview-src-list="previewFiles(scope.row.uploadFiles)">
            <div slot="error"
                 class="image-slot">
              <img src="@images/watermark.jpg"
                   style="width: 40px; height: 40px;"
                   alt="" />
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       align="center">
        <template slot-scope="scope">
          <span class="edit"
                @click="showEditDialog(scope.row)">编辑</span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="推荐"
               :visible.sync="isShowEditDialog"
               :before-close="handleDialogClose"
               width="50%">
      <el-form :model="editForm"
               ref="editFormRef"
               :rules="editFormRules"
               label-width="80px"
               label-position="left">
        <el-form-item label="物料名称">
          {{ editForm.productName }}
        </el-form-item>
        <el-form-item label="品项">
          {{ editForm.qualityName }}
        </el-form-item>
        <el-form-item label="数量"
                      prop="quantity"
                      required>
          <el-input-number v-model="editForm.quantity"
                           :precision="0"
                           :min="1"
                           clearable
                           size="mini"></el-input-number>
        </el-form-item>
        <el-form-item label="价格"
                      prop="price"
                      required>
          <el-input-number v-model="editForm.price"
                           :precision="2"
                           :min="1"
                           clearable
                           size="mini"></el-input-number>
        </el-form-item>
        <el-form-item label="有效期"
                      prop="priceDate">
          <el-date-picker v-model="editForm.priceDate"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择日期时间"
                          :picker-options="pickerOptions"
                          size="mini"
                          style="width: 180px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="产品图片"
                      prop="productPictures"
                      class="pictures-item">
          <div class="addPictures">
            <el-upload action="/api/services/inquiryApp/uploadFile/PostFile"
                       list-type="picture-card"
                       :before-upload="handleBeforeUpload"
                       :file-list="editForm.uploadFiles"
                       :on-success="handleUploadSuccess"
                       :on-remove="handleUploadRemove"
                       :on-preview="handleUploadPreview"
                       :limit="5"
                       :on-exceed="handleUploadExceed"
                       style="width: 100px, height: 100px">
              <i class="el-icon-plus"></i>
            </el-upload>
            <p>请上传格式为jpeg、jpg或png，大小不超过5MB的图片，最多5张</p>
          </div>
        </el-form-item>
        <el-form-item label="备注"
                      prop="remark">
          <el-input v-model="editForm.remark"
                    placeholder="请输入"
                    clearable
                    type="textarea"
                    style="width:400px;"
                    :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleDialogCancel"
                   size="mini">取 消</el-button>
        <el-button type="primary"
                   @click="confirmAdded"
                   size="mini">确定上架</el-button>
      </span>
    </el-dialog>
    <!-- 上传图片预览对话框 -->
    <el-dialog :visible.sync="isShowPreviewDialog">
      <img width="100%"
           :src="previewImageUrl"
           alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    productList: {
      type: Array,
      default: () => [
        {
          createOn: '',
          productName: '',
          orderQuantity: '',
          price: 0,
          priceDate: '',
          qualityName,
          qualityId: '',
          remark: '',
          uploadFiles: [
            {
              contentType: '',
              id: 1,
              name: '',
              sitePath: ''
            }
          ]
        }
      ]
    }
  },
  data () {
    return {
      isShowEditDialog: false,
      editForm: {},
      editFormRules: {
        productName: [
          { required: true, message: '请输入物料名称', trigger: 'blur' }
        ],
        qualityId: [{ required: true, message: '请选择品项', trigger: 'blur' }],
        priceDate: [
          { required: true, message: '请选择截止日', trigger: 'blur' }
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      isShowPreviewDialog: false,
      previewImageUrl: ''
    }
  },
  created () { },
  methods: {
    previewFiles (files) {
      let arr = []
      if (files) {
        files.forEach(item => {
          arr.push(item.sitePath)
        })
      }
      return arr
    },
    showEditDialog (data) {
      let arr = []
      data.uploadFiles.forEach(item => {
        arr.push({
          url: item.sitePath,
          item
        })
      })
      this.isShowEditDialog = true
      this.editForm = JSON.parse(JSON.stringify(data))
      this.editForm.priceDate = ''
      this.editForm.uploadFiles = arr
    },
    handleBeforeUpload (file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isJpgOrPng) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isJpgOrPng && isLt5M
    },
    handleUploadSuccess (response, file, fileList) {
      this.editForm.uploadFiles.push({
        url: file.response.result[0].sitePath,
        item: file.response.result[0]
      })
    },
    handleUploadRemove (file, fileList) {
      this.editForm.uploadFiles = fileList
    },
    handleUploadPreview (file) {
      this.previewImageUrl = file.url
      this.isShowPreviewDialog = true
    },
    handleUploadExceed (files, fileList) {
      this.$message.warning('最多上传5张图片')
    },
    handleDialogClose (done) {
      this.editForm.uploadFiles = []
      this.editForm.priceDate = ''
      done()
    },
    handleDialogCancel () {
      this.isShowEditDialog = false
      this.editForm.uploadFiles = []
      this.editForm.priceDate = ''
    },
    confirmAdded () {
      this.$refs.editFormRef.validate(valid => {
        if (valid) {
          let uploadFiles = []
          this.editForm.uploadFiles.forEach(item => {
            uploadFiles.push(item.item)
          })
          const params = {
            quantity: this.editForm.quantity,
            price: this.editForm.price,
            priceDate: this.editForm.priceDate,
            uploadFiles: uploadFiles,
            remark: this.editForm.remark,
            id: this.editForm.id
          }
          this.$http
            .post(
              '/api/services/inquiryApp/productRecommend/AgainAdded',
              params
            )
            .then(res => {
              if (res.result) {
                this.$message.success('重新上架成功！')
                this.isShowEditDialog = false
                this.editForm.uploadFiles = []
                this.editForm.priceDate = ''
              }
            })
            .catch(err => {
              this.$message.error(err.data.error.message)
            })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.expired-container {
  height: 100%;
  overflow: auto;
}
.edit {
  color: #40adfb;
  cursor: pointer;
}
.el-form-item {
  margin-bottom: 10;
  display: flex;
  align-items: center;
  /deep/ .el-form-item__content {
    margin-left: 40px !important;
  }
}
.pictures-item {
  margin-top: 10px;
  margin-bottom: 15px;
  /deep/ .el-form-item__label {
    height: 60px !important;
    line-height: 60px;
  }
}
.addPictures {
  /deep/ div {
    height: 60px;
    font-size: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    ul {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      li {
        margin-bottom: 0;
        .el-upload-list__item-status-label {
          display: none;
        }
        .el-upload-list__item-actions {
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;
          font-size: 15px;
        }
      }
    }
  }
  /deep/ .el-upload-list__item-delete {
    margin-left: 0;
  }
  /deep/ .el-upload--picture-card {
    width: 60px !important;
    height: 60px !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 60px !important;
    height: 60px !important;
  }
}
</style>
